import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class FunctionExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.FunctionExpression;
    }
    visitNode(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.functionLike);
    }
}

//# sourceMappingURL=FunctionExpressionCompiler.js.map
